export const PERCENT = '%';

export const FIXED = 'USD'; // According to API response - it refers to fixed discount.

export const DISCOUNT_UNITS = {
    PERCENT: PERCENT,
    [FIXED]: FIXED
};

export const USD = '$';
export const CURRENCIES = {
    USD: USD,
};

export const ALLOW_AUTO_INCREASE_FLAG = false;

export const ALLOW_SHOWING_NON_APPLICABLE_FEATURED_FLAG = true;

export const MINIMUM_ALLOWED_PRODUCT_PRICE = 0.01;

export const MINIMUM_ALLOWED_ORDER_TOTAL = 0.5;

export const PAYMENT_PAYPAL_ENABLED = true;
export const CUSTOM_BILLS_ID = 'custom_bills';
export const ID_ANTI_SPAM = 1;
export const ID_SITE_SECURITY= 4;

/**
 * @see https://cleantalk.org/price-database-api
 */
export const PRODUCT_DB_API_LEVEL_BY_SERVICES = [
    // "amount" specifies the number of services more or equal to.
    { amount: 1, id: 1 },
    { amount: 250000, id: 2 },
    { amount: 1000000, id: 3 },
    { amount: 6000000, id: 4 }
];

export const PRODUCT_DB_API_LABEL_FORMATTER = {
    match: /Block Lists, ([^,]+), ([^$]+)/,
    groupLabel: '$2',
    optionLabel: '$1',
    replacer: (base, dict) => {
        if (typeof base !== 'string') {
            return '';
        }

        // Если нет совпадений — просто возвращаем исходную строку
        if (!dict || typeof dict !== 'object') {
            return base;
        }

        return base.replace(/\$(\d+)/g, (_, index) => {
            return dict[index] ?? '';
        });
    },
}

export const FEATURED_PRODUCTS_PAIR = {
    1: {
        name: 'Anti-Spam',
        code: 'anti-spam',
        description:
            'Plugins, API to protect websites against spam signups, orders, comments and contact message.',
        products: [4, 6],
        active: true,
        defaults: {
            tariff_services: 3,
            period: 'Year',
            period_interval: 3,
        },
        allowedAsSeparate: true
    },
    2: {
        name: 'Block Lists',
        code: 'database_api',
        description: 'API, SFTP access of spam active IP, Emails. Daily updates.',
        products: [],
        active: true,
        allowedAsSeparate: true,
        defaults: {
            tariff_services: 50000,
            period: 'Month',
            period_interval: 3,
        },
    },
    4: {
        name: 'Security',
        code: 'security',
        description:
            'Malware scans, FireWall, Web Application Fire Wall and protection against Brute-Force attacks.',
        products: [1, 6],
        active: true,
        defaults: {
            tariff_services: 3,
            period: 'Year',
            period_interval: 3,
        },
        allowedAsSeparate: true
    },
    5: {
        name: 'SSL Certificates',
        code: 'ssl_certificate',
        description: 'Domain validation certificate, HTTPS access to your site.',
        products: [1, 4, 6],
        active: true,
        allowedAsSeparate: true
    },
    6: {
        name: 'Uptime monitoring',
        code: 'uptime_monitoring',
        description: 'Notifications about site status and HTTP response time.',
        products: [1, 4],
        active: true,
        allowedAsSeparate: true
    },
    7: {
        name: 'doBoard',
        code: 'doboard',
        description: 'doBoard - a tasks management system for a team',
        products: [],
        active: true,
        defaults: {
            tariff_services: 3,
            period: 'Month',
            period_interval: 12,
        },
        allowedAsSeparate: true
    },
    'custom_bills' : {
        name: 'Custom bills',
        code: 'customBills',
        description: '',
        products: [],
        active: true,
        defaults: {},
        allowedAsSeparate: true
    },
};
